import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import * as styles from "./radioDial.styles";
export var RadioDial = function RadioDial(props) {
  return /*#__PURE__*/React.createElement(_StyledInput, _extends({}, props, {
    type: "radio",
    $_css: styles.input
  }));
};
var _StyledInput = /*#__PURE__*/_styled("input").withConfig({
  displayName: "RadioDial___StyledInput",
  componentId: "sc-kzsaf2-0"
})(["", ""], function (p) {
  return p.$_css;
});